import { ApiEndpointSpecification } from './types';
import { HttpMethod } from '../http-request';
import * as Helpers from '../api-request-helpers';
import * as Types from '../types';
import { MANAGE_ALARM_DEVICE_CHANNEL_COUNT } from './url-constants';

type ManageAlarmsDeviceChannelCountEndpointSpecification = ApiEndpointSpecification;
export const ManageAlarmsDeviceChannelCountEndpointSpecification: ManageAlarmsDeviceChannelCountEndpointSpecification = {
    url: MANAGE_ALARM_DEVICE_CHANNEL_COUNT,
    method: HttpMethod.POST,
    requestParamsSchemaName: 'ManageAlarmsDeviceChannelCountRequestParams',
    requestBodySchemaName: 'ManageAlarmsDeviceChannelCountRequestBody',
    okResponseSchemaName: 'ManageAlarmsDeviceChannelCountOkResponse',
    notOkResponseSchemaName: 'GenericNotOkResponse',
    authenticated: true,
    version:3
};

export const invokeManageAlarmDeviceChannelCount = Helpers.makeApiRequestFn<
    Types.ManageAlarmsDeviceChannelCountRequestParams,
    Types.ManageAlarmsDeviceChannelCountRequestBody,
    Types.ManageAlarmsDeviceChannelCountOkResponse
>(ManageAlarmsDeviceChannelCountEndpointSpecification);
